import { UPDATE_SIDEBAR_STATUS } from "../actionTypes";

const initialState = {
  isSidebarOpen: false,
};

const sidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_SIDEBAR_STATUS:
      return {
        ...state,
        isSidebarOpen: action.payload,
      };
    default:
      return state;
  }
};

export default sidebarReducer;
